import React from "react";
import { Route } from "react-router-dom";
import { residentEditTabDefinitions } from "../Containers/Resident/ResidentEdit/residentEditTabsConfig";

const Resident = React.lazy(() => import("../Containers/Resident"));
const ResidentEditTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentEditTabs"),
);
const PreAssessmentAdd = React.lazy(
  () => import("../Containers/Resident/ResidentPreAssessment/PreAssessmentAdd"),
);
const ResidentSettingsTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentSettingsTabs"),
);
const ResidentAdd = React.lazy(
  () => import("../Containers/Resident/ResidentAdd"),
);
const ResidentAssessmentsTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentAssessmentsTabs"),
);
const ResidentCarePlanTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentCarePlanTabs"),
);
const ResidentComplianceTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentComplianceTabs"),
);
const ResidentInsightsToolsTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentInsightsToolsTabs"),
);
const ResidentLocationRulesTabs = React.lazy(
  () => import("../Containers/Resident/Tabs/ResidentLocationRulesTabs"),
);
const ResidentPreAssessment = React.lazy(
  () => import("../Containers/Resident/ResidentPreAssessment"),
);
const ResidentCarePlanTeam = React.lazy(
  () => import("../Containers/Resident/ResidentSettings/CarePlanTeam"),
);
const ResidentGroups = React.lazy(
  () => import("../Containers/Resident/ResidentSettings/ResidentGroups"),
);
const ResidentCareRoundTypes = React.lazy(
  () => import("../Containers/Resident/ResidentSettings/CareRoundTypes"),
);
const ResidentCareRounds = React.lazy(
  () => import("../Containers/Resident/ResidentSettings/CareRounds"),
);
const ResidentCareRoundEdit = React.lazy(
  () =>
    import("../Containers/Resident/ResidentSettings/CareRounds/CareRoundEdit"),
);

const residentEditPaths = residentEditTabDefinitions.map((tab) => ({
  path: `/d/resident/edit/:id/${tab.slug}`,
  component: () => <ResidentEditTabs />,
}));

const legacyResidentEditPaths = [
  {
    path: "/d/resident/edit/:id/upload-documents",
    component: () => <ResidentEditTabs />,
  },
  {
    path: "/d/resident/edit/:id/basic-information",
    component: () => <ResidentEditTabs />,
  },
];

const ResidentRoutes = ({ itemValidator }) => {
  return (
    <>
      <Route
        exact
        path="/d/resident"
        render={() => itemValidator(<Resident />, `RESIDENT`, `DISPLAY`)}
      />
      {[...residentEditPaths, ...legacyResidentEditPaths].map((path) => (
        <Route
          exact
          key={path.path}
          path={path.path}
          render={() => itemValidator(path.component(), `RESIDENT`, `DISPLAY`)}
        />
      ))}
      <Route
        exact
        path="/d/resident/add"
        render={() => itemValidator(<ResidentAdd />, `RESIDENT`, `DISPLAY`)}
      />
      <Route
        exact
        path="/d/resident/pre-assessment-list"
        render={() =>
          itemValidator(<ResidentPreAssessment />, `RESIDENT`, `DISPLAY`)
        }
      />

      <Route
        exact
        path="/d/r/settings/medical-condition"
        render={() =>
          itemValidator(<ResidentSettingsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/resident/pre-assessment/add"
        render={() => itemValidator(<PreAssessmentAdd />, `RESIDENT`, `WRITE`)}
      />
      <Route
        exact
        path="/d/resident/pre-assessment/edit/:id"
        render={() =>
          itemValidator(
            <PreAssessmentAdd isEditing={true} />,
            `RESIDENT`,
            `WRITE`,
          )
        }
      />
      <Route
        exact
        path="/d/r/settings/generic"
        render={() =>
          itemValidator(<ResidentSettingsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/devices"
        render={() =>
          itemValidator(<ResidentSettingsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />

      <Route
        exact
        path="/d/r/settings/assessments"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/needs"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/risk"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/medical-condition"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/assessments/capacity"
        render={() =>
          itemValidator(<ResidentAssessmentsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/care-plan"
        render={() =>
          itemValidator(<ResidentCarePlanTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/care-team"
        render={() =>
          itemValidator(<ResidentCarePlanTeam />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/resident-groups"
        render={() => itemValidator(<ResidentGroups />, `RESIDENT`, `DISPLAY`)}
      />
      <Route
        exact
        path="/d/r/settings/care-round-types"
        render={() =>
          itemValidator(<ResidentCareRoundTypes />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/care-rounds"
        render={() =>
          itemValidator(<ResidentCareRounds />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/care-rounds/edit/:id"
        render={() =>
          itemValidator(<ResidentCareRoundEdit />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance"
        render={() =>
          itemValidator(<ResidentComplianceTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance/safeguarding"
        render={() =>
          itemValidator(<ResidentComplianceTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance/consent"
        render={() =>
          itemValidator(<ResidentComplianceTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/compliance/governance"
        render={() =>
          itemValidator(<ResidentComplianceTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/insights"
        render={() =>
          itemValidator(<ResidentInsightsToolsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/insights/charts"
        render={() =>
          itemValidator(<ResidentInsightsToolsTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
      <Route
        exact
        path="/d/r/settings/location-rules"
        render={() =>
          itemValidator(<ResidentLocationRulesTabs />, `RESIDENT`, `DISPLAY`)
        }
      />
    </>
  );
};

export default ResidentRoutes;
